import readCookie from 'shared-utils/src/cookies/readCookie';
import deleteCookie from 'shared-utils/src/cookies/deleteCookie';

const socialHandleLogin = ({ 
  href = '', 
  useWorkaround = false,
  cookiesConfig: { 
    cookieRememberMeKey = 'remember_me',
    cookieSessionPortal = 'session_portal',
    newSocialUserKey = 'new_social_user',
  } = { }, 
  onDone = () => { } }) => {
  let popUp;

  /**
   * TECH-5436
   * The code above on setInterval is due to a double facebook redirect on login
   * that causes a reference's loss to the primary window.
   *
   * It could be raise a leak if the jwt is always false, but the global var on window
   * reduces this leak at maximun one instance.
   */
  clearInterval(window.__socialGlobalInterval);
  let interval = setInterval(function () {
    const hasJwt = readCookie(cookieRememberMeKey);
    if (hasJwt && hasJwt !== 'undefined') {
      const sess = readCookie(cookieSessionPortal);
      const newSocialUser = readCookie(newSocialUserKey);
      if (newSocialUser) {
        deleteCookie(newSocialUserKey);
      }
      clearInterval(interval);
      popUp.close();
      onDone && onDone({ jwt: sess, isNew: newSocialUser });
    }
  }, 1000);

  window.__socialGlobalInterval = interval;

  const windowWidth = 580; // 580 is max width to avoid FB warning
  const windowHeight = 595; // 595 is max height to avoid FB warning
  const left = window.screen.width / 2 - windowWidth / 2
  const top = window.screen.height / 2 - windowHeight / 2

  if (useWorkaround) {
    popUp = window.open('https://casa.it', 'Social Sign-In', `menubar=no,location=no,scrollbars=no,status=no,width=${windowWidth},height=${windowHeight},top=${top},left=${left}`);
  }
  popUp = window.open(href, 'Social Sign-In', `menubar=no,location=no,scrollbars=no,status=no,width=${windowWidth},height=${windowHeight},top=${top},left=${left}`);
}

export default socialHandleLogin;